exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".office-account-field{font-size:14px;pointer-events:none;color:grey}", ""]);

// exports
